
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404yoDfLRI9S2I7qfv17iC5_45JPriBgmUOK4QDkrCSqJazUMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/404.vue?macro=true";
import { default as indexbARr17YI29D6j4RhEwCs_p5wLTwLYHIA5AGmzrDW2RQMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/index.vue?macro=true";
import { default as _91path_93NnX8bxe36rTVcxCSi55CUHXLy40q7iBnc8nCDGkFtTwMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/om/[path].vue?macro=true";
import { default as feature_45flagU1QvQ1FAqkqCK2sHIvxRYUitjPlDtbWZFjoBXDe6WZwMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/feature-flag.vue?macro=true";
import { default as _91path_93Dr9Wv4Q2iva_45pbVyj0ojHY_45g_45GWi45gK76coeGqwyd0Meta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/artikler/[path].vue?macro=true";
import { default as _91path_93fNHC_45yQ_4yCfeon_45rGGx_45r77r33gibFg_oeNFDS_45zKMMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/studentliv/[path].vue?macro=true";
import { default as search_45offlineKEOGtOw2zIQOFOsfJCLyjmLhK0uLecrAUZRYF_XKPUcMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/[product]/search-offline.vue?macro=true";
import { default as indextEzVf7a1BbZKBLla_452y6X_45JuRufjWzXSfVVs_45DM9MfgMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/index.vue?macro=true";
import { default as betaling86gREKdMpBV704H1dW5lc_45DHnE3Xuu3cMoCTg8pZ75UMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/betaling.vue?macro=true";
import { default as logg_45innHVnoQBK_459OLq6busT5bTu5ELNXdBSDGwsHhGzARJVaoMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/logg-inn.vue?macro=true";
import { default as sokFkGTBa_45YGHFb7h_45fNNkCSzgmHx98JR_wligxlDN1Zo8Meta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/[variant]/sok.vue?macro=true";
import { default as indexjWL1V6lBoqC_a0avGfRWBxsF_JzqkToesczRCjxS_XQMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/[variant]/index.vue?macro=true";
import { default as begreperfB9dsm3GqKkmsw7yTn_WaeQfT_4p1Y8kwXHxYRIQHQsMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/[variant]/begreper.vue?macro=true";
import { default as min_45siderHPhadk2Hi2YuCEB2PBRKOqM4g6To_45YPtNXvWItQTfoMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/[variant]/min-side.vue?macro=true";
import { default as registrer_45interessefANDCpLfou72wA5wXOLpnNKZK9qa5yWuYp9LQT4cyVoMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/registrer-interesse.vue?macro=true";
import { default as index8njZcX6VT_BC8gGHlJUpQjpc_45DjXSg_45lAXdGcVgdfSQMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/[variant]/[subject]/index.vue?macro=true";
import { default as min_45sideFyLeizHuRXCUNWd0SOcEejE7byG_FdcWBq3ph1ki7oMMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/[variant]/[subject]/min-side.vue?macro=true";
import { default as _91article_93aa6_45Y8SBZVkCKRU1OiF58Ebsy6LGHlow_QmVzJ3w9CwMeta } from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/[variant]/[subject]/[article].vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    meta: _404yoDfLRI9S2I7qfv17iC5_45JPriBgmUOK4QDkrCSqJazUMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/404.vue")
  },
  {
    name: "hjem",
    path: "/",
    meta: indexbARr17YI29D6j4RhEwCs_p5wLTwLYHIA5AGmzrDW2RQMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/index.vue")
  },
  {
    name: "om-path",
    path: "/om/:path()",
    meta: _91path_93NnX8bxe36rTVcxCSi55CUHXLy40q7iBnc8nCDGkFtTwMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/om/[path].vue")
  },
  {
    name: "featureFlag",
    path: "/feature-flag",
    meta: feature_45flagU1QvQ1FAqkqCK2sHIvxRYUitjPlDtbWZFjoBXDe6WZwMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/feature-flag.vue")
  },
  {
    name: "artikler-path",
    path: "/artikler/:path()",
    meta: _91path_93Dr9Wv4Q2iva_45pbVyj0ojHY_45g_45GWi45gK76coeGqwyd0Meta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/artikler/[path].vue")
  },
  {
    name: "studentliv-path",
    path: "/studentliv/:path()",
    meta: _91path_93fNHC_45yQ_4yCfeon_45rGGx_45r77r33gibFg_oeNFDS_45zKMMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/studentliv/[path].vue")
  },
  {
    name: "search-offline",
    path: "/:product()/search-offline",
    meta: search_45offlineKEOGtOw2zIQOFOsfJCLyjmLhK0uLecrAUZRYF_XKPUcMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/[product]/search-offline.vue")
  },
  {
    name: "product",
    path: "/produkter/:product()",
    meta: indextEzVf7a1BbZKBLla_452y6X_45JuRufjWzXSfVVs_45DM9MfgMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/index.vue")
  },
  {
    name: "productCheckout",
    path: "/produkter/:product()/betaling",
    meta: betaling86gREKdMpBV704H1dW5lc_45DHnE3Xuu3cMoCTg8pZ75UMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/betaling.vue")
  },
  {
    name: "login",
    path: "/produkter/:product()/logg-inn",
    meta: logg_45innHVnoQBK_459OLq6busT5bTu5ELNXdBSDGwsHhGzARJVaoMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/logg-inn.vue")
  },
  {
    name: "search",
    path: "/produkter/:product()/:variant()/sok",
    meta: sokFkGTBa_45YGHFb7h_45fNNkCSzgmHx98JR_wligxlDN1Zo8Meta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/[variant]/sok.vue")
  },
  {
    name: "variant",
    path: "/produkter/:product()/:variant()",
    meta: indexjWL1V6lBoqC_a0avGfRWBxsF_JzqkToesczRCjxS_XQMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/[variant]/index.vue")
  },
  {
    name: "begreper",
    path: "/produkter/:product()/:variant()/begreper",
    meta: begreperfB9dsm3GqKkmsw7yTn_WaeQfT_4p1Y8kwXHxYRIQHQsMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/[variant]/begreper.vue")
  },
  {
    name: "produkter-product-variant-min-side",
    path: "/produkter/:product()/:variant()/min-side",
    meta: min_45siderHPhadk2Hi2YuCEB2PBRKOqM4g6To_45YPtNXvWItQTfoMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/[variant]/min-side.vue")
  },
  {
    name: "registerInterest",
    path: "/produkter/:product()/registrer-interesse",
    meta: registrer_45interessefANDCpLfou72wA5wXOLpnNKZK9qa5yWuYp9LQT4cyVoMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/registrer-interesse.vue")
  },
  {
    name: "subject",
    path: "/produkter/:product()/:variant()/:subject()",
    meta: index8njZcX6VT_BC8gGHlJUpQjpc_45DjXSg_45lAXdGcVgdfSQMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/[variant]/[subject]/index.vue")
  },
  {
    name: "produkter-product-variant-subject-min-side",
    path: "/produkter/:product()/:variant()/:subject()/min-side",
    meta: min_45sideFyLeizHuRXCUNWd0SOcEejE7byG_FdcWBq3ph1ki7oMMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/[variant]/[subject]/min-side.vue")
  },
  {
    name: "article",
    path: "/produkter/:product()/:variant()/:subject()/:article()",
    meta: _91article_93aa6_45Y8SBZVkCKRU1OiF58Ebsy6LGHlow_QmVzJ3w9CwMeta || {},
    component: () => import("/builds/aschehoug/universitetsforlaget/kunne-spa/app/pages/produkter/[product]/[variant]/[subject]/[article].vue")
  }
]